import React, { Component } from 'react';
import { SelectButton } from 'primereact/selectbutton';
import { Calendar } from 'primereact/calendar';
import { UtilService } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import Template from '../../../models/Template';
import DashboardPeriodoEnum from '../../../enums/DashboardPeriodoEnum';

const PERIODO_MES = 'main.dashboard.periodo.mes';
const PERIODO_ANO = 'main.dashboard.periodo.ano';
const PERIODO_CUSTOM = 'main.dashboard.periodo.periodo';

// Filtros do Dashboard — espelho de hay-hotspot/.../DashboardFiltros.js, com o dropdown de
// Routerboard trocado por Template (LinkInsight filtra Links por Template, não por equipamento).
class DashboardFiltros extends Component {
  getRenderer(path) {
    const renderers = {
      'template.entidade': Template,
    };
    return renderers[path] || null;
  }

  buildContextoTemplate() {
    return {
      getRenderer: (path) => this.getRenderer(path),
      traduzir: (chave) => UtilService.traduzir(chave),
      traduzirHelp: () => '',
      traduzirModel: () => UtilService.traduzir('main.dashboard.filtro.template'),
      camporelacao: 'descricao',
      updateModelPath: (_path, valor) => this.props.onChangeTemplate(valor),
    };
  }

  renderCalendar() {
    const { periodo, data, dataFim, onChangeData, onChangeRange } = this.props;

    if (periodo === PERIODO_CUSTOM) {
      const valor = [data ? new Date(data) : null, dataFim ? new Date(dataFim) : null];
      return (
        <Calendar
          selectionMode="range"
          value={valor}
          showIcon
          dateFormat="dd/mm/yy"
          onChange={(e) => onChangeRange(e.value?.[0]?.getTime() || null, e.value?.[1]?.getTime() || null)}
          className="w-full"
        />
      );
    }

    if (periodo === PERIODO_MES) {
      return (
        <Calendar
          view="month"
          value={data ? new Date(data) : null}
          showIcon
          dateFormat="mm/yy"
          onChange={(e) => onChangeData(e.value ? e.value.getTime() : null)}
          className="w-full"
        />
      );
    }

    if (periodo === PERIODO_ANO) {
      return (
        <Calendar
          view="year"
          value={data ? new Date(data) : null}
          showIcon
          dateFormat="yy"
          onChange={(e) => onChangeData(e.value ? e.value.getTime() : null)}
          className="w-full"
        />
      );
    }

    return (
      <Calendar
        value={data ? new Date(data) : null}
        showIcon
        dateFormat="dd/mm/yy"
        onChange={(e) => onChangeData(e.value ? e.value.getTime() : null)}
        className="w-full"
      />
    );
  }

  render() {
    const { periodo, template, onChangePeriodo } = this.props;
    const opcoesPeriodo = DashboardPeriodoEnum.getOptions().map((op) => ({
      label: UtilService.traduzir(op.descricao),
      value: op.id,
    }));

    return (
      <div className="grid align-items-end">
        <div className="field col-12 md:col-3">
          <label className="block mb-2 font-medium">{UtilService.traduzir('main.dashboard.filtro.periodo')}</label>
          <SelectButton
            value={periodo}
            options={opcoesPeriodo}
            unselectable={false}
            onChange={(e) => e.value && onChangePeriodo(e.value)}
            pt={{ root: { style: { display: 'flex', width: '100%' } }, button: { style: { flex: 1 } } }}
          />
        </div>
        <div className="field col-12 md:col-4">
          <label className="block mb-2 font-medium">{UtilService.traduzir('main.dashboard.filtro.data')}</label>
          {this.renderCalendar()}
        </div>
        <div className="field col-12 md:col-5">
          <ModelDropDown
            model={{
              exibir: 'main.dashboard.filtro.template',
              entidade: 'template.entidade',
              value: template,
              camporelacao: 'descricao',
            }}
            contexto={this.buildContextoTemplate()}
          />
        </div>
      </div>
    );
  }
}

export default DashboardFiltros;
